import { HubSpotForm, JoinFormType, PackagePrices } from 'types/join';

export const formatPlan = (plan: string) => {
  switch (plan.toLowerCase().replaceAll('_', '')) {
    case 'pricesheetmonthly':
      return 'Rapaport Plus';
    case 'pricesheetweekly':
      return 'Rapaport Basic';
    case 'rapaportplus':
      return 'Rapaport Plus';
    case 'rapaportbasic':
      return 'Rapaport Basic';
    case 'rapaportresearchreport':
      return 'Rapaport Research Report';
    case 'rapnetbuyerpro':
      return 'RapNet Buyer Pro';
    case 'rapnetbuyer':
      return 'RapNet Buyer';
    case 'rapnetdealer':
      return 'RapNet Dealer';
    case 'rapnetbuyerproindia':
      return 'RapNet Buyer Pro India';
    case 'rapnetbuyerindia':
      return 'RapNet Buyer India';
    case 'rapnetprimarysupplier':
      return 'RapNet Primary Supplier';
    case 'rapnetgemdealer':
      return 'RapNet Gem Dealer';
    case 'rapnetgembuyer':
      return 'RapNet Gem Buyer';
    default:
      return plan;
  }
};

type CreateHubSpotFormProps = {
  form: JoinFormType;
  selectedPlan: PackagePrices;
  sourcePage: string;
};
export const CreateHubSpotForm = ({
  selectedPlan,
  form,
  sourcePage
}: CreateHubSpotFormProps): HubSpotForm => {
  let isFromRapaport = false;
  if (sourcePage.includes('rapaport.com')) {
    isFromRapaport = true;
  }
  const hutk = document.cookie
    .split('; ')
    .find(row => row.startsWith('hubspotutk='))
    ?.split('=')[1];

  // Extract UTM parameters from URL
  const urlParams = new URLSearchParams(window.location.search);
  const utmCampaign = urlParams.get('utm_campaign') || '';
  const utmSource = urlParams.get('utm_source') || '';
  const utmMedium = urlParams.get('utm_medium') || '';
  const utmContent = urlParams.get('utm_content') || '';
  const utmTerm = urlParams.get('utm_term') || '';
  const landingPage = urlParams.get('landing_page') || window.location.href;
  const conversionPage = urlParams.get('conversion_page') || window.location.href;

  let leadsource = 'Registration - RapNet';
  if (isFromRapaport) {
    leadsource = 'Registration - Rapaport';
  }
  const context: any = {
    pageUri: window.location.href,
    pageName: document.title
  };

  if (hutk) {
    context.hutk = hutk;
  }
  const hbsptForm: HubSpotForm = {
    fields: [
      { name: 'firstname', value: form.firstName || '' },
      { name: 'lastname', value: form.lastName || '' },
      { name: 'email', value: form.email || '' },
      { name: 'country', value: form.companyCountry || '' },
      { name: 'marketing_primary_company_type', value: form.companyType || '' },
      { name: 'sync_to_hubspot', value: false },
      { name: 'leadsource', value: leadsource },
      { name: 'initial_plan_pick', value: formatPlan(form.initialPlan || '') },
      { name: 'requested_plan_pick', value: selectedPlan.packageName },
      { name: 'utm_campaign_temp', value: utmCampaign },
      { name: 'utm_source_temp', value: utmSource },
      { name: 'utm_medium_temp', value: utmMedium },
      { name: 'utm_content__temp_', value: utmContent },
      { name: 'utm_term__temp_', value: utmTerm },
      { name: 'landing_page_temp', value: landingPage },
      { name: 'conversion_page_temp', value: conversionPage }
    ],
    context
  };

  return hbsptForm;
};
